<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Email Alerts', to: { path: '/email-alerts' } },
        {
          name: 'Subscriber Page',
          to: { path: '/email-alerts/subscriber-page' },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>Subscriber Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
      <button class="btn" @click="deleteHandler">
        <v-icon class="mr-2">delete</v-icon>
        <span>刪除</span>
      </button>
    </div>
    <!--  -->
    <div class="block">
      <!-- Name -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ name }}</div>
      </label>
      <!-- Company -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Company</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ company }}</div>
      </label>
      <!-- Email -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Email</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ email }}</div>
      </label>
      <!-- Title -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ title }}</div>
      </label>
      <!-- Type -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Type</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ type }}</div>
      </div>
      <!-- Mobile -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Mobile</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ mobile ? mobile : 'Nan' }}
        </div>
      </label>
      <!-- Tel -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Tel</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ tel ? tel : 'Nan' }}</div>
      </label>
      <!-- Fax -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Fax</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ fax ? fax : 'Nan' }}</div>
      </label>
      <!-- Address -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Address</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ address ? address : 'Nan' }}
        </div>
      </label>
      <!-- Unsubscribe -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Unsubscribe</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <button
            v-if="subscribeStatus === '未訂閱'"
            class="btn btn-outlined"
            :style="{
              width: '117px',
            }"
            @click="setSubscribeStatus(true)"
          >
            Subscribe
          </button>
          <button
            v-else
            class="btn btn-outlined danger-500--text"
            :style="{
              border: '1px solid #f60000',
              width: '117px',
            }"
            @click="setSubscribeStatus(false)"
          >
            Unsubscribe
          </button>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  data: () => ({
    name: "Subscriber's Name",
    company: 'ADATA BANK',
    email: 'hello@wasateam.com',
    type: 'Banker',
    title: 'Product Manager',
    mobile: '',
    tel: '',
    fax: '',
    address: '',
    subscribeStatus: '已訂閱',
  }),
  methods: {
    editHandler() {
      this.$router.push('/email-alerts/subscriber-edit');
    },
    deleteHandler() {
      this.$router.push('/email-alerts');
    },
    setSubscribeStatus(status) {
      if (status === true) {
        this.subscribeStatus = '已訂閱';
      } else {
        this.subscribeStatus = '未訂閱';
      }
    },
  },
};
</script>

<style></style>
